export default {
  routes_home: 'Home',
  routes_take_duet: 'Take Duet',
  routes_duet_profile: 'View & manage profile',
  routes_assessment_results: 'Assessment results',
  routes_download_assessment_results: 'Download assessment results',
  routes_users: 'Users',
  routes_access_logs: 'Access logs',
  routes_configure_school: `Configure school`,
  routes_configure_users: 'Configure users',
  routes_manage_permissions: 'Manage permissions',
  routes_configure_menu: 'Configure menu',
  routes_configure_integrations: 'Configure integrations',
  routes_terms_and_conditions: 'Terms & conditions',
  routes_signin: 'Sign in',
  routes_reset_password: 'Reset password',
  routes_taggings_and_embellishments: 'Taggings & embellishments',
  routes_manage_users: 'Manage users',
  routes_edit_user: 'Edit user',
  routes_not_found: '404 - Page not found',
  routes_forbidden: '403 - Forbidden',
  routes_logout: 'Logout',
  routes_create_user: 'Create user',
  routes_create_admin: 'Create admin',
  routes_account: 'Account',
  routes_version: 'Version'
};
